


export class ServiceRequestClaimContext {

    public routeTo: string[] = [];
    public bookingId: string = "";
    constructor() {

    }
}